import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import App from './App'
import './styles/index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
})

// 政务蓝主题
const theme = {
  token: {
    colorPrimary: '#1a5fb4',
    colorSuccess: '#26a269',
    colorWarning: '#e5a50a',
    colorError: '#c01c28',
    colorInfo: '#1c71d8',
    borderRadius: 4,
    fontSize: 14,
  },
  components: {
    Layout: {
      headerBg: '#1a5fb4',
      siderBg: '#ffffff',
    },
    Menu: {
      darkItemBg: '#1a5fb4',
      darkItemSelectedBg: '#0d3a7a',
    },
  },
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider locale={zhCN} theme={theme}>
          <App />
        </ConfigProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
